import script from "./MarketingCloudForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingCloudForm.vue?vue&type=script&setup=true&lang=js"

import "./MarketingCloudForm.vue?vue&type=style&index=0&id=3a5b859e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5b859e"]])

export default __exports__